import React from 'react';
import { Button, FocusTrap, Group, Modal } from '@mantine/core';
import { getArchimageModalProps } from './modalConfig';

export { getArchimageModalProps, blockModalEnterKey, generateEphemeralCode } from './modalConfig';

export default function ArchimageModal({
  styles,
  children,
  showCloseFooter = false,
  closeFooterLabel = 'Fermer',
  scrollBody = true,
  onClose,
  ...props
}) {
  const { styles: baseStyles, ...modalDefaults } = getArchimageModalProps();
  const compactModalStyles = scrollBody
    ? {}
    : {
        content: {
          overflowY: 'hidden',
          overflow: 'hidden',
          maxHeight: 'none',
          height: 'auto',
        },
        body: {
          overflow: 'visible',
          flex: 'unset',
          minHeight: 'auto',
        },
      };

  return (
    <Modal
      {...modalDefaults}
      styles={{
        ...baseStyles,
        ...compactModalStyles,
        ...styles,
        content: {
          maxHeight: scrollBody ? 'calc(100dvh - 7rem)' : 'none',
          overflow: scrollBody ? 'hidden' : 'hidden',
          overflowY: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          height: scrollBody ? undefined : 'auto',
          ...baseStyles?.content,
          ...compactModalStyles?.content,
          ...styles?.content,
        },
        header: { ...baseStyles?.header, ...styles?.header },
        title: { ...baseStyles?.title, ...styles?.title },
        body: {
          flex: scrollBody ? 1 : 'unset',
          minHeight: scrollBody ? 0 : 'auto',
          overflow: scrollBody ? 'hidden' : 'visible',
          display: 'flex',
          flexDirection: 'column',
          ...baseStyles?.body,
          ...compactModalStyles?.body,
          ...styles?.body,
        },
      }}
      onClose={onClose}
      {...props}
    >
      <FocusTrap.InitialFocus />
      {scrollBody ? (
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </div>
      ) : (
        children
      )}
      {showCloseFooter && onClose ? (
        <Group justify="flex-end" mt="md" style={{ flexShrink: 0 }}>
          <Button variant="default" onClick={onClose}>
            {closeFooterLabel}
          </Button>
        </Group>
      ) : null}
    </Modal>
  );
}
